import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    install: 'Install',
    connect: 'Connect',
    detected: 'Detected',
  },
};
